import * as React from 'react';

import { VideoChatContainer } from 'containers/project-love/features/video-chat-container';

const Page: React.FunctionComponent = () => {
  return <VideoChatContainer />;
};

export default Page;

export { getServerSideProps } from 'lib/get-server-side-props';
